<script setup lang="ts">
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';

import logoSrc from '@/assets/logo-nav.png';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import UserMenu from '@/components/UserMenu.vue';

const t = inject<(key: string, options?: Record<string, unknown>) => string>('t')!;
const route = useRoute();

// Only the onboarding and spaces flows have an authenticated user to show.
const hasUserMenu = computed(() => route.path.startsWith('/onboarding') || route.path.startsWith('/spaces'));
</script>

<template>
  <header class="sticky top-0 z-40 border-b border-af-grey-200 bg-white" data-cy="navbar">
    <div class="flex h-16 items-center gap-5 px-3 sm:px-5">
      <a href="/login" class="grid place-items-center" data-cy="navbar-logo">
        <img :src="logoSrc" :alt="t('accessibility.link.login')" width="48" height="48" />
      </a>

      <div class="ms-auto flex items-center gap-4">
        <LanguageSwitcher />
        <UserMenu v-if="hasUserMenu" />
      </div>
    </div>
  </header>
</template>
